<template>
  <div :class="['navbar-area', { 'is-sticky': isSticky }]">
    <div class="vdemy-nav">
      <div class="container-fluid">
        <nav class="navbar navbar-expand-lg navbar-light">
          <router-link class="navbar-brand" to="/">
            <img :src="getImgUrl('resimler', image.image_image)" v-for="image of images " alt="logo" />
          </router-link>
          <div class="navbar-toggler" @click="active = !active" :aria-pressed="active ? 'true' : 'false'"
            v-bind:class="{ active: button_active_state }" v-on:click="button_active_state = !button_active_state">
            <i class="bx bx-menu"></i>
            <i class="bx bx-x"></i>
          </div>
          <div class="collapse navbar-collapse" :class="{ toggler: active }">
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link to="/" class="nav-link">
                  Ana Sayfa
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="siniflarimiz" class="nav-link">
                  Sınıflarımız
                </router-link>
              </li>
              <li class="nav-item megamenu">
                <router-link to="kurslarimiz" class="nav-link">
                  Kurslarımız
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="etkinliklerimiz" class="nav-link">
                  Etkinliklerimiz
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="bloglar" class="nav-link">
                  Bloglar
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="hakkimizda" class="nav-link">
                  Hakkımızda
                </router-link>
              </li>
            </ul>
          </div>

          <div class="others-option d-flex align-items-center">
            <div class="option-item">
              <router-link to="/iletisim" class="default-btn">
                <i class="flaticon-user"></i>
                İletişime Geç
                <span></span>
              </router-link>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios";

export default {
  name: "Navbar",

  created() {
    this.getImages();
  },
  data() {
    return {
      isSticky: false,
      active: false,
      button_active_state: false,
      images: [],
      errors: [],
      pathUrl: 'https://dryyazilim.com.tr/anaokulu/assets/data/get.php'
    };
  },
  mounted() {
    const that = this;
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        that.isSticky = true;
      } else {
        that.isSticky = false;
      }
    });
  },
  methods: {
    getImages() {
      axios.get(this.pathUrl + "?data=image&parent=11")
        .then(response => (this.images = response.data.result))
        .catch(error => {
          this.errors.push(error);
        });
    },
    getImgUrl(category, pet) {
      return require('../../../../assets/resimler/' + category + '/' + pet)
    }
  }
};
</script>
